import * as React from 'react';
import { colors } from '../../../index';

const IconBlockchain = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 17 17",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.092.256L8.928 2.982l.26 1.479-1.37-.52-3.164 2.727.273 1.55-1.503-.57L.26 10.375 1 14.58l3.906 1.48 3.165-2.727-.273-1.549 1.502.57 3.165-2.727-.26-1.478 1.37.519 3.164-2.726L16 1.736 12.092.256zm3.02 1.824L12.77 4.097 9.88 3.003 12.22.985l2.891 1.095zM9.316 5.19l.288 1.636-1.11.957-2.89-1.095 2.342-2.017 1.37.52zm2.082 1.973l-.84-.318.68-.586.16.904zm-1.245-.81l-.16-.906.843.319-.683.588zM5.056 8.948l.263 1.494-1.217 1.048-2.89-1.094 2.34-2.017 1.504.569zm1.937 1.851l-.773-.293.626-.54.147.833zm-1.125-.83l-.135-.765.71.27-.575.495zM1 10.996l2.89 1.095.549 3.11-2.89-1.094L1 10.996zm6.393 2.08l-2.341 2.018-.548-3.111 1.166-1.005 1.45.55.273 1.549zm-1.79-4.602l-.208-1.185 2.89 1.095.548 3.111-1.164-.44-.34-1.927-1.725-.654zm6.184.896l-2.34 2.017-.55-3.112 1.113-.957 1.517.574.26 1.478zM9.866 4.717l-.197-1.113 2.89 1.094.55 3.112-1.032-.39-.353-1.999-1.858-.704zm3.855 2.985l-.548-3.112 2.341-2.017.549 3.112-2.342 2.017z",
    fill: "currentColor"
  }));
};

export default IconBlockchain;